import ArrowForward from '@mui/icons-material/ArrowForward'
import { Box, Button, ButtonProps, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ReactNode } from 'react'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import { useAppSelector } from 'store/useStoreHook'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'

interface ILoginBottomProps {
    hideIdLogin: boolean
    onClick: () => void
}

const IconBox = ({ children }: { children: ReactNode }) => (
    <Box
        component={'span'}
        sx={{
            border: '1px solid white',
            borderRadius: '50%',
            padding: '7px 9px',
            lineHeight: '1',
        }}
    >
        {children}
    </Box>
)

const CustomButton = (props: ButtonProps) => {
    return (
        <Button
            {...props}
            sx={{
                color: (theme) =>
                    theme.palette.primary.contrastText + ' !important',
                textTransform: 'none',
            }}
        />
    )
}

function LoginBottom({ hideIdLogin, onClick }: ILoginBottomProps) {
    const { t } = useTranslation()
    const theme = useTheme()

    const data = useAppSelector((state) => state.tenantIdentifierInfo.data)
    const { isMobile, isLandscapeMobile, isMediumScreen } = useScreenSize()

    return (
        <>
            <Box
                display={'flex'}
                justifyContent={'center'}
                position={isMobile ? 'static' : 'relative'}
                bottom={isLandscapeMobile ? 16 : isMobile ? 40 : 20}
                pb={hideIdLogin ? 2 : 0}
                width={'100%'}
            >
                <Typography color="primary.contrastText" textAlign={'center'}>
                    <span style={{ color: '#55f000' }}>
                        <LocationOnIcon
                            sx={{
                                marginRight: theme.spacing(1),
                                marginBottom: '-5px',
                                width: '20px',
                            }}
                        />
                    </span>
                    {data.locationName ?? ''}
                </Typography>
            </Box>

            {!hideIdLogin && (
                <Box
                    display={'flex'}
                    justifyContent={'flex-end'}
                    position={isMobile ? 'relative' : 'absolute'}
                    right={5}
                    bottom={5}
                >
                    <CustomButton
                        variant="text"
                        onClick={onClick}
                        endIcon={
                            <IconBox>
                                <ArrowForward />
                            </IconBox>
                        }
                    >
                        <Typography align="right">
                            {isMediumScreen
                                ? 'ID Login'
                                : t('login.message.turn_to_normal_login')}
                        </Typography>
                    </CustomButton>
                </Box>
            )}
        </>
    )
}

export default LoginBottom
